import { useState } from "react";
import { useIntl } from "react-intl";
import { TGetCandidateContractsCollectionItem } from "../../../../../../api/contract/apiListCandidateContracts";
import { useAuthUser } from "../../../../../../reducers/hooks/useAuthUser";
import { CONTRATO_ESTADO_FIN_DE_CONTRATO } from "../../../../../../util/defaults/contrato";
import ContractFieldCell from "../ContractFieldCell/ContractFieldCell";
import EditEmployeeValuationDialog from "../EditEmployeeValuationDialog/EditEmployeeValuationDialog";
import EmployeeValuationHistoryDialog from "../EmployeeValuationHistoryDialog/EmployeeValuationHistoryDialog";

type TEmployeeValuationCellProps = {
  contract: TGetCandidateContractsCollectionItem;
};

const EmployeeValuationCell = ({ contract }: TEmployeeValuationCellProps) => {
  const { formatMessage } = useIntl();
  const { permissions } = useAuthUser();
  const [editOpen, setEditOpen] = useState(false);
  const [historyOpen, setHistoryOpen] = useState(false);

  const isFinished = contract.Estado === CONTRATO_ESTADO_FIN_DE_CONTRATO;
  const canEdit = isFinished && permissions.canEditContractEmployeeValuation;

  return (
    <>
      <ContractFieldCell
        value={contract.Valoracion_Cuideo_Candidata}
        noWrap
        showEdit={canEdit}
        showHistory={isFinished}
        onEdit={() => setEditOpen(true)}
        onHistory={() => setHistoryOpen(true)}
        editLabel={formatMessage({
          id: "EmployeeValuation.Editar valoración",
          defaultMessage: "Editar valoración",
        })}
        historyLabel={formatMessage({
          id: "EmployeeValuation.Ver histórico de la valoración",
          defaultMessage: "Ver histórico de la valoración",
        })}
      />
      {isFinished && (
        <EmployeeValuationHistoryDialog
          open={historyOpen}
          contractId={contract.id}
          contractName={contract.Name}
          onClose={() => setHistoryOpen(false)}
        />
      )}
      {canEdit && (
        <EditEmployeeValuationDialog
          open={editOpen}
          contractId={contract.id}
          contractName={contract.Name}
          currentValue={contract.Valoracion_Cuideo_Candidata}
          onClose={() => setEditOpen(false)}
        />
      )}
    </>
  );
};

export default EmployeeValuationCell;
